import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const [expandedService, setExpandedService] = useState(null);

  const services = [
    {
      id: 1,
      title: 'Accident Repairs',
      icon: '🚗',
      price: '£200 - £3000',
      description: 'Complete accident repair services for all types of vehicle damage',
      details: [
        'Frame straightening and alignment',
        'Panel replacement',
        'Welding services',
        'Structural repairs',
        'Full diagnostics included',
      ],
      process: 'Damage assessment → Repair planning → Parts sourcing → Repair work → Quality inspection',
    },
    {
      id: 2,
      title: 'Dent Removal',
      icon: '🔨',
      price: '£80 - £500',
      description: 'Professional dent removal without repainting',
      details: [
        'Paintless dent removal',
        'Door dent repair',
        'Bumper dents',
        'Panel dents',
        'Quick turnaround',
      ],
      process: 'Assessment → Tool selection → Dent removal → Final touches',
    },
    {
      id: 3,
      title: 'Scratch Repairs',
      icon: '✨',
      price: '£50 - £300',
      description: 'Minor and major scratch repairs with color matching',
      details: [
        'Surface scratch repair',
        'Deep scratch treatment',
        'Paint touch-up',
        'Exact color matching',
        'Insurance approved',
      ],
      process: 'Scratch assessment → Surface preparation → Paint application → Finishing',
    },
    {
      id: 4,
      title: 'Full Body Respray',
      icon: '🎨',
      price: '£1000 - £4000',
      description: 'Complete vehicle repainting for full transformation',
      details: [
        'Complete paint stripping',
        'Surface preparation',
        'Primer application',
        'Color matching',
        'Multi-layer paint system',
        'Clear coat protection',
      ],
      process: 'Prep work → Stripping → Primer → Base coat → Clear coat → Finishing',
    },
    {
      id: 5,
      title: 'Alloy Wheel Repair',
      icon: '🛞',
      price: '£60 - £150 per wheel',
      description: 'Professional alloy wheel repair and refurbishment',
      details: [
        'Curb damage repair',
        'Crack welding',
        'Rim straightening',
        'Paint refinishing',
        'Balancing included',
      ],
      process: 'Inspection → Repair → Surface prep → Painting → Balancing',
    },
    {
      id: 6,
      title: 'Paint Correction & Polishing',
      icon: '⚙️',
      price: '£150 - £600',
      description: 'Restore shine and remove imperfections from your paint',
      details: [
        'Swirl mark removal',
        'Oxidation treatment',
        'Multi-stage polishing',
        'Paint protection applied',
        'Ceramic coating available',
      ],
      process: 'Inspection → Machine polishing → Fine polishing → Protection application',
    },
    {
      id: 7,
      title: 'Insurance Work',
      icon: '💳',
      price: 'Price Varies',
      description: 'Comprehensive insurance claim repair services',
      details: [
        'Direct insurance billing',
        'No upfront costs',
        'Quick claim processing',
        'All repair types covered',
        'Expert assessment',
      ],
      process: 'Claim review → Inspection → Repair authorization → Work completion',
    },
  ];

  return (
    <main className="services-page">
      {/* Header */}
      <section className="services-header">
        <div className="container">
          <h1>Our Services</h1>
          <p>Professional car body repair services with guaranteed quality</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section container p-40">
        <div className="services-list">
          {services.map((service) => (
            <div
              key={service.id}
              className={`service-item ${expandedService === service.id ? 'expanded' : ''}`}
            >
              <div
                className="service-header"
                onClick={() =>
                  setExpandedService(expandedService === service.id ? null : service.id)
                }
              >
                <div className="service-title-section">
                  <span className="service-icon">{service.icon}</span>
                  <div className="service-head-text">
                    <h3>{service.title}</h3>
                    <p className="service-desc">{service.description}</p>
                  </div>
                </div>
                <div className="service-price-section">
                  <span className="service-price">{service.price}</span>
                  <span className="toggle-icon">
                    {expandedService === service.id ? '−' : '+'}
                  </span>
                </div>
              </div>

              {expandedService === service.id && (
                <div className="service-details">
                  <div className="details-grid">
                    <div className="details-column">
                      <h4>Service Includes:</h4>
                      <ul className="details-list">
                        {service.details.map((detail, idx) => (
                          <li key={idx}>
                            <span className="checkmark">✓</span> {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="details-column">
                      <h4>Process:</h4>
                      <p className="process">{service.process}</p>
                      <div className="service-actions">
                        <Link to="/quote" className="btn btn-primary">
                          Get Custom Quote
                        </Link>
                        <Link to="/contact" className="btn btn-secondary">
                          Contact Us
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section container p-40">
        <h2 className="text-center">Why Choose West Drayton Body Works?</h2>
        <div className="grid grid-3">
          <div className="feature-card">
            <span className="feature-icon">⭐</span>
            <h3>Expert Technicians</h3>
            <p>15+ years of experience in automotive body repair with certified professionals</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">💰</span>
            <h3>Competitive Pricing</h3>
            <p>Best rates in West Drayton with transparent pricing and no hidden costs</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔒</span>
            <h3>Quality Guarantee</h3>
            <p>All repairs backed by our quality guarantee - we stand behind our work</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Fast Turnaround</h3>
            <p>Quick service without compromising on quality - get your car back fast</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🛡️</span>
            <h3>Insurance Approved</h3>
            <p>Direct insurance billing available - no upfront costs for insured repairs</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">✓</span>
            <h3>Certified Work</h3>
            <p>Certified by major vehicle manufacturers - all modern vehicles covered</p>
          </div>
        </div>
      </section>

      {/* Pricing Info */}
      <section className="pricing-info p-40">
        <div className="container">
          <h2 className="text-center">Pricing Information</h2>
          <div className="pricing-grid">
            <div className="pricing-box">
              <h3>Free Consultation</h3>
              <p>
                Bring your vehicle in for a free assessment. Our experts will evaluate the damage
                and provide an accurate quote.
              </p>
            </div>
            <div className="pricing-box">
              <h3>Custom Quotes</h3>
              <p>
                Every vehicle and damage is unique. We provide personalized quotes based on your
                specific needs and requirements.
              </p>
            </div>
            <div className="pricing-box">
              <h3>Flexible Payment</h3>
              <p>
                Multiple payment options available. Direct insurance billing, card payments, or
                bank transfer - choose what suits you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="services-cta">
        <div className="container">
          <h2>Get Your Free Quote Today</h2>
          <p>Contact us for a no-obligation assessment and pricing</p>
          <Link to="/quote" className="btn btn-primary btn-large">
            Request a Quote
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Services;
